import { Button } from '@warp-ds/react';
import cn from 'classnames';
import { useRouter } from 'next/router';
import { useConfig } from 'shared/config/ConfigContext';
import styles from './LoginToSeeProfile.module.css';

export const LoginToSeeProfile = () => {
    const { baseUrl, contextPath } = useConfig();
    const router = useRouter();
    const redirectUrl = encodeURIComponent(`${baseUrl}${contextPath}${router.asPath}`);
    const loginUrl = `${baseUrl}/auth/login?redirectUrl=${redirectUrl}`;

    return (
        <div data-testid="TrustProfileNotLoggedIn" className="p-16 border rounded-8">
            <div className={cn(styles.profilePublic, 'center')}>
                <div className={styles.avatar}>
                    <img
                        alt="Bilde av en anonym avatar"
                        className="w-[54] h-[54] rounded-full"
                        src="https://images.finncdn.no/dynamic/220x220c/profile_placeholders/default"
                    />{' '}
                </div>
                <div className="flex-col">
                    <h4>Privat utleier</h4>

                    <div className="text-14 mb-8">Du må være logget inn for å se brukerprofiler og sende forespørsler.</div>
                    <Button secondary fullWidth href={loginUrl}>
                        Logg inn
                    </Button>
                </div>
            </div>
        </div>
    );
};
